import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPaginationActionTypes {
  Request = 'PAGINATION/REQUEST',
  Success = 'PAGINATION/SUCCESS',
  Failure = 'PAGINATION/FAILURE',
}

export type TPaginationSuccess = ITypedReduxAction<EPaginationActionTypes.Success>;
export type TPaginationRequest = ITypedReduxAction<EPaginationActionTypes.Request>;
export type TPaginationFailure = ITypedReduxAction<EPaginationActionTypes.Failure>;

export const paginationSuccess: () => TPaginationSuccess = actionGenerator<EPaginationActionTypes.Success>(
  EPaginationActionTypes.Success,
);

export const paginationRequest: () => TPaginationRequest = actionGenerator<EPaginationActionTypes.Request>(
  EPaginationActionTypes.Request,
);

export const paginationFailure: () => TPaginationFailure = actionGenerator<EPaginationActionTypes.Failure>(
  EPaginationActionTypes.Failure,
);

export type TPaginationActionTypes = TPaginationRequest | TPaginationSuccess | TPaginationFailure;
